import { Grid } from '@mui/material';
import React, { useState } from 'react';

import CommentContent from './CommentContent';
import NewComment from './NewComment';

import { type TaskComment, type CommentReaction } from '@/graphql/generated/graphql';

interface CommentReplyProps {
  comment: TaskComment;
  taskId: string;
  index: number;
  setMainCommentId: () => void;
  getReactorsInfo: (reaction: CommentReaction) => JSX.Element;
}

const CommentReply: React.FC<CommentReplyProps> = ({ comment, taskId, setMainCommentId, getReactorsInfo }) => {
  const [selectedComment, setSelectedComment] = useState<TaskComment | null>(null);

  const handleReplyClick = () => setMainCommentId();
  const handleEditClick = () => setSelectedComment(comment);

  return (
    <Grid key={`reply-${comment.id}`}>
      {selectedComment ? (
        <NewComment taskId={taskId} selectedComment={selectedComment} setSelectedComment={setSelectedComment} />
      ) : (
        <CommentContent
          comment={comment}
          onReplyClick={handleReplyClick}
          onEditClick={handleEditClick}
          getReactorsInfo={getReactorsInfo}
          isReply={true}
        />
      )}
    </Grid>
  );
};

export default CommentReply;
